import { render, staticRenderFns } from "./create-itinerary.vue?vue&type=template&id=0edb7684&"
import script from "./create-itinerary.vue?vue&type=script&lang=js&"
export * from "./create-itinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports